module.exports = __webpack_public_path__ + "static/media/quiz-mob.bfe1ae9e.jpg";